export default {
    auth: {
        attendance_success: "📅 เช็คชื่อเรียบร้อย! (Daily Rewards)\nได้รับโบนัสวันนี้ +50 คะแนน!",
        signup_bonus: "ลงทะเบียนสำเร็จ! 🎉\nได้รับโบนัสต้อนรับ +100 คะแนน!",
        referral_bonus: "ลงทะเบียนผ่านคำเชิญเรียบร้อย! 🤝\nโบนัสต้อนรับ 100P + โบนัสแนะนำ 500P\nรวมได้รับ 600 คะแนน!",
        login_required: "ต้องเข้าสู่ระบบ"
    },
    social: {
        subscribe_on: "เพิ่มในรายการติดตามแล้ว",
        subscribe_off: "ยกเลิกการติดตามแล้ว",
        like_on: "ถูกใจ!",
        like_off: "ยกเลิกถูกใจ",
        follow_on: "ติดตามแล้ว",
        follow_off: "เลิกติดตามแล้ว"
    },
    comment: {
        submit_success: "โพสต์ความคิดเห็นแล้ว",
        delete_confirm: "คุณแน่ใจหรือไม่ที่จะลบ?",
        delete_success: "ลบแล้ว",
        delete_error: "เกิดข้อผิดพลาดในการลบ",
        submit_error: "เกิดข้อผิดพลาดในการโพสต์ความคิดเห็น",
        empty_error: "กรุณากรอกเนื้อหา"
    },
    payment: {
        verify_success: "ยืนยันเรียบร้อย!\nเติม {amount} ดาวแล้ว",
        verify_fail: "การยืนยันล้มเหลว",
        user_cancel: "การชำระเงินถูกยกเลิก",
        error: "การชำระเงินผิดพลาด"
    },
    common: {
        confirm: "ยืนยัน",
        cancel: "ยกเลิก",
        close: "ปิด",
        save: "บันทึก",
        delete: "ลบ",
        edit: "แก้ไข",
        copy: "คัดลอก",
        loading: "กำลังโหลด...",
        error: "เกิดข้อผิดพลาด",
        success: "สำเร็จ",
        webtoon: "เว็บตูน",
        webnovel: "นวนิยายเว็บ",
        cinenovel: "Cine-Novel",
        published: "เผยแพร่แล้ว",
        draft: "ร่าง",
        editor: "บรรณาธิการ"
    },
    seo: {
        default_title: "Mirinae Platform - Where Imagination Becomes Reality",
        default_desc: "Next-gen Webtoon/Webnovel platform combining AI and Art. Become an author and create your own universe."
    },
    footer: {
        terms: "ข้อกำหนดการใช้งาน",
        privacy: "นโยบายความเป็นส่วนตัว",
        report: "ศูนย์ร้องเรียน",
        biz_ceo: "ซีอีโอ",
        biz_addr: "ที่อยู่",
        biz_tel: "สนับสนุน",
        biz_email: "อีเมล",
        biz_license: "ใบอนุญาต",
        biz_mail_order: "อีคอมเมิร์ซ",
        biz_none: "ไม่มีข้อมูล",
        system_ready: "SYSTEM READY",
        copyright: "SSULWHA WORLD"
    },
    menu: {
        home: "หน้าแรก",
        webtoon: "เว็บตูน",
        webnovel: "นิยายเว็บ",
        novel: "นิยายเว็บ",
        davinci: "ดา วินชี",
        studio: "สตูดิโอผู้สร้าง",
        library: "ห้องสมุด",
        support: "สนับสนุน",
        admin: "ผู้ดูแลระบบ",
        config: "ลิงก์ภายนอก",
        factory: "ป๊อปอัป & การแจ้งเตือน",
        docs: "ตัวแก้ไขเอกสาร",
        analytics: "วิเคราะห์แนวโน้ม",
        plaza: "คลับ Ssulwha",
        wisdom: "ภูมิปัญญาแห่งดวงดาว",
        recommendation: "ชั้นหนังสือว่างเปล่า",
        charge: "สถานีดวงดาว",
        guide: "คู่มือ",
        "whats-new": "มีอะไรใหม่",
        invite: "เชิญเพื่อน",
        about: "เกี่ยวกับบริการ",
        terms: "ข้อกำหนดการใช้งาน",
        privacy: "นโยบายความเป็นส่วนตัว",
        report: "ศูนย์ร้องเรียน",
        "app-setting": "ตั้งค่าแอป",
        login: "เข้าสู่ระบบ / ลงทะเบียน",
        logout: "ออกจากระบบ",
        MyPage: "หน้าของฉัน",
        notice: "ประกาศ",
        proposal: "ข้อเสนอ",
        settings: "การตั้งค่า",
        language: "ภาษา"
    },
    modal: {
        translate_title: "เลือกภาษา",
        translate_placeholder: "โปรดเลือกภาษาที่จะแปล",
        translate_start: "แปลภาษา"
    },
    msg: {
        welcome_beta: "ยินดีต้อนรับสู่ Mirinae รุ่นเบต้า",
        login_required: "เข้าสู่ระบบเพื่อปลดล็อกเรื่องราวเพิ่มเติม",
        login_btn: "เข้าสู่ระบบ / ลงทะเบียน"
    },
    profile: {
        follow: "ติดตาม",
        following: "กำลังติดตาม",
        mypage: "หน้าของฉัน",
        followers: "ผู้ติดตาม",
        following_count: "กำลังติดตาม",
        bio_empty: "ไม่มีข้อมูลแนะนำตัว",
        works: "ผลงาน",
        feed: "ฟีด",
        guestbook: "สมุดเยี่ยม",
        works_empty: "ไม่มีผลงานที่ลงทะเบียน",
        works_error: "โหลดผลงานล้มเหลว",
        feed_empty: "ไม่มีโพสต์",
        feed_error: "โหลดฟีดล้มเหลว",
        feed_error_detail: "กำลังสร้างดัชนีหรือข้อผิดพลาดเครือข่าย",
        follow_error: "การติดตามล้มเหลว"
    },
    support: {
        title: "ศูนย์บริการช่วยเหลือ 1:1",
        input_placeholder: "กรอกข้อสงสัยของคุณ...",
        empty_state_title: "ไม่มีประวัติการปรึกษา",
        empty_state_desc: "ถามเราได้ทุกเมื่อ!",
        status_received: " • ได้รับแล้ว",
        auto_reply: "ได้รับความคิดเห็นของคุณแล้ว เราจะตอบกลับตามลำดับ ในระหว่างนี้ เชิญเพลิดเพลินกับ Ssulwha World",
        send_fail: "ส่งข้อความล้มเหลว"
    },
    author: {
        apply_title: "สมัครเป็นนักเขียน",
        apply_desc: "แบ่งปันเรื่องราวของคุณกับโลก ฝากคำแนะนำสั้นๆ และผลงาน เราจะติดต่อกลับหลังจากตรวจสอบ",
        email_label: "อีเมล",
        email_placeholder: "กรอกอีเมลติดต่อ",
        email_hint: "เราอาจติดต่อคุณเกี่ยวกับผลการอนุมัติและสัญญา",
        intro_label: "แนะนำตัว",
        intro_placeholder: "โปรดแนะนำตัวเอง (ประสบการณ์การเขียน, สไตล์ ฯลฯ)",
        portfolio_label: "ผลงาน (ไม่บังคับ)",
        submit_btn: "สมัครเลย",
        email_required: "โปรดกรอกอีเมลของคุณ",
        intro_required: "โปรดกรอกข้อมูลแนะนำตัว",
        submitting: "กำลังส่ง...",
        submit_success: "ส่งใบสมัครนักเขียนเรียบร้อยแล้ว"
    },
    point: {
        reason: {
            attendance: "Daily Attendance",
            reading: "Reading Reward",
            reading_reward: "Reading Reward",
            welcome: "Welcome Reward",
            referral: "Referral Reward",
            author_apply: "Author Application",
            rental: "Rental",
            purchase: "Purchase"
        }
    },
    wallet: {
        tab_title: "Wallet",
        sub_card: {
            upgrade_btn: "Upgrade Membership (₩{price}/mo)",
            coming_soon: "Coming Soon",
            tier_label: "Membership Tier",
            tier_premium: "Premium Pass",
            tier_standard: "Standard Member",
            renews_on: "Renews on"
        },
        assets: {
            activity_label: "Activity Points",
            activity_desc: "Free Earned Points",
            star_label: "Star Points",
            star_desc: "Paid Charged Points"
        },
        charge: {
            title: "Star Station",
            desc: "Charge needed stars"
        },
        history: {
            title: "Point History",
            empty: "No history found."
        }
    },

    library: {
        empty_title: "ห้องสมุดว่างเปล่า",
        empty_desc: "ผลงานที่ซื้อหรือดูจะปรากฏที่นี่",
        explore_btn: "สำรวจผลงาน",
        select_hint: "เลือกผลงานเพื่อดูรายการ",
        total_episodes: "ทั้งหมด {n} ตอน"
    },
    badge: {
        best_reviewer: "สุดยอดนักวิจารณ์",
        top_author: "นักเขียนยอดเยี่ยม",
        vip: "VIP",
        donation_king: "ราชาแห่งการบริจาค",
        hall_of_fame: "หอเกียรติยศ"
    },
    tab: {
        works: "ผลงาน",
        feed: "Ssulwha (Feed)",
        guestbook: "สมุดเยี่ยม"
    },
    tag: {
        fantasy: "แฟนตาซี",
        romance: "โรแมนติก",
        martial_arts: "กำลังภายใน",
        drama: "ดราม่า",
        slice_of_life: "ชีวิตประจำวัน",
        comedy: "ตลก",
        thriller: "ระทึกขวัญ",
        school: "โรงเรียน",
        munchkin: "เทพทรู",
        regression: "ย้อนเวลา",
        possession: "สิงร่าง",
        system: "ระบบ",
        growth: "เติบโต",
        revenge: "แก้แค้น",
        heart: "อบอุ่นหัวใจ",
        horror: "สยองขวัญ",
        sport: "กีฬา",
        history: "ประวัติศาสตร์ย้อนยุค"
    },
    history: {
        empty: {
            title: "No history yet.",
            desc: "Shall we explore some works?",
            action_btn: "Go Explore"
        },
        common: {
            no_title: "No Title"
        },
        last_viewed: "Last viewed:",
        episode_fmt: "Ep. {n}",
        delete_confirm: {
            msg: "Do you want to delete this history?",
            title: "Delete History"
        }
    },
    guestbook: {
        title: "สมุดเยี่ยม",
        input_placeholder: "ฝากข้อความสนับสนุน!",
        secret: "ความลับ",
        submit: "ส่ง",
        empty: "เป็นคนแรกที่ฝากข้อความ! 👣",
        secret_content: "นี่คือข้อความลับ",
        delete_confirm: "คุณแน่ใจหรือไม่ที่จะลบ?",
        reply: "ตอบกลับ",
        reply_placeholder: "เขียนคำตอบ...",
        reply_delete_confirm: "ลบคำตอบ?",
        confirm_delete_reply: "ลบคำตอบนี้?",
        submit_error: "ส่งล้มเหลว: ",
        emoji_error: "โหลดอิโมจิล้มเหลว"
    },
    pwa: {
        install_title: "ติดตั้ง",
        install_desc: "เร็วกว่าและดีกว่า",
        install_btn: "ติดตั้ง",
        later_btn: "ภายหลัง",
        ios_guide_title: "ติดตั้งบน iPhone",
        ios_guide_desc: "เพลิดเพลินกับประสบการณ์เต็มหน้าจอ",
        ios_step1: "แตะปุ่ม 'แชร์'",
        ios_step2: "เลือก 'เพิ่มไปยังหน้าจอหลัก'",
        update_title: "เวอร์ชันใหม่ ({version})!",
        update_title_v2: "มีเวอร์ชันใหม่พร้อมใช้งานแล้ว!",
        update_desc: "อัปเดตเพื่อรับคุณสมบัติใหม่",
        update_btn: "อัปเดต",
        updating: "กำลังอัปเดต...",
        offline_title: "คุณออฟไลน์อยู่",
        offline_desc: "โปรดตรวจสอบอินเทอร์เน็ต",
        copy_success: "คัดลอกแล้ว",
        copy_fail: "คัดลอกล้มเหลว"
    },
    settings: {
        title: "การตั้งค่าแอป",
        general: "ทั่วไป",
        push_title: "การแจ้งเตือนแบบพุช",
        push_desc: "รับการแจ้งเตือนการอัปเดต",
        app_info: "ข้อมูลแอป",
        current_version: "เวอร์ชันปัจจุบัน",
        danger_zone: "เขตอันตราย",
        delete_account_title: "ลบบัญชี (กลับสู่ความเป็นจริง)",
        delete_account_desc: "ข้อมูลทั้งหมดจะถูกลบและไม่สามารถกู้คืนได้",
        delete_account_button: "กลับสู่ความเป็นจริง"
    },
    proposal: {
        title: "ภูมิปัญญาแห่งดวงดาว",
        desc: "ภูมิปัญญาอันเจิดจรัสของคุณขยายจักรวาล",
        label_title: "หัวข้อข้อเสนอ",
        placeholder_title: "ป้อนแก่นไอเดียของคุณ",
        label_content: "รายละเอียด",
        placeholder_content: "แบ่งปันไอเดียของคุณได้อย่างอิสระ ยิ่งละเอียดยิ่งดี!",
        btn_submit: "ส่งภูมิปัญญา",
        success_title: "ได้รับภูมิปัญญาแล้ว",
        success_desc: "ภูมิปัญญาของ {name} ถูกบันทึกแล้ว<br>ขอบคุณสำหรับคำติชมที่มีค่าของคุณ"
    },
    report: {
        title: "ศูนย์ร้องเรียน",
        category_label: "หมวดหมู่",
        content_label: "เนื้อหา",
        url_label: "URL ที่เกี่ยวข้อง",
        categories: {
            general: "คำถามทั่วไป / อื่นๆ",
            spam: "สแปม / โฆษณาไม่เหมาะสม",
            abuse: "การด่าทอ / วาจาสร้างความเกลียดชัง",
            adult: "เนื้อหาสำหรับผู้ใหญ่ / เป็นอันตรายต่อผู้เยาว์",
            bug: "ข้อผิดพลาดของระบบ / บั๊ก"
        },
        placeholder_content: "โปรดอธิบายปัญหาโดยละเอียด",
        btn_submit: "ส่งคำร้องเรียน",
        warning: "การแจ้งเท็จอาจนำไปสู่การจำกัดการใช้บริการ",
        success_title: "ส่งคำร้องเรียนแล้ว",
        success_desc: "เราจะตรวจสอบและดำเนินการอย่างรวดเร็ว<br>ขอบคุณสำหรับการรายงาน",
        login_required: "คุณต้องเข้าสู่ระบบเพื่อรายงาน",
        submit_success: "ส่งคำร้องเรียนเรียบร้อยแล้ว\nโปรดตรวจสอบในศูนย์ดูแลระบบ...",
        error: "เกิดข้อผิดพลาดขณะส่งคำร้องเรียน",
        modal: {
            title: "Report",
            desc: "Please select a reason. False reports may result in service restrictions.",
            category: "Category",
            detail: "Detail",
            url: "Related URL",
            submit: "Submit",
            cancel: "Cancel"
        },
        reason: {
            spam: "Spam / Promotion",
            abusive: "Abusive Language",
            inappropriate: "Inappropriate Content",
            other: "Other / Inquiry"
        }
    },
    guide: {
        title: "การตั้งค่าระบบ",
        desc: "เรากำลังปรับแต่งเข็มทิศอย่างละเอียด<br>เพื่อช่วยในการเดินทางของคุณ",
        wait: "กรุณารอสักครู่"
    },
    viewer: {
        settings_title: "การตั้งค่าเสียง/การเลื่อน",
        bgm_volume: "ระดับเสียง BGM",
        bgm_off: "ปิด BGM",
        auto_speed: "ความเร็วอัตโนมัติ",
        settings_btn: "การตั้งค่า",
        translate_btn: "แปล AI",
        tts_btn: "อ่าน TTS",
        bgm_btn: "BGM",
        top_btn: "บนสุด",
        auto_play: "สไลด์อัตโนมัติ",
        auto_scroll: "เลื่อนอัตโนมัติ",
        start_auto: "เล่นอัตโนมัติ",
        stop_auto: "หยุดแล้ว",
        tts_warn: "หมายเหตุ: TTS อ่านในภาษาต้นฉบับ (เกาหลี)"
    },
    login: {
        subtitle: "ที่ซึ่งจินตนาการของคุณกลายเป็นความจริง",
        btn_google: "ดำเนินการต่อด้วย Google",
        or: "หรือ",
        label_email: "อีเมล",
        label_password: "รหัสผ่าน",
        btn_email_login: "เข้าสู่ระบบด้วยอีเมล",
        btn_email_signup: "สมัครด้วยอีเมล",
        msg_no_account: "ไม่มีบัญชี?",
        msg_has_account: "มีบัญชีอยู่แล้ว?",
        btn_signup: "สมัครสมาชิก",
        btn_login: "เข้าสู่ระบบ",
        msg_processing: "กำลังประมวลผล...",
        msg_email_sent: "ส่งอีเมลยืนยันแล้ว โปรดตรวจสอบและเข้าสู่ระบบ",
        err_invalid_auth: "อีเมลหรือรหัสผ่านไม่ถูกต้อง",
        err_email_in_use: "อีเมลนี้ถูกใช้ไปแล้ว",
        err_default: "เกิดข้อผิดพลาด"
    },
    terms: {
        title: "การตรวจคนเข้าเมือง",
        desc: "ยินดีต้อนรับสู่โลก SSULWHA<br>โปรดยอมรับข้อกำหนดการใช้งาน",
        required: "[จำเป็น]",
        optional: "[ทางเลือก]",
        label_terms: "เงื่อนไขการให้บริการ",
        label_privacy: "นโยบายความเป็นส่วนตัว",
        label_marketing: "การยินยอมทางการตลาด",
        btn_start: "เริ่มต้น",
        btn_processing: "กำลังประมวลผล..."
    },
    main: {
        banner_welcome: "✨ สำรวจโลก SSULWHA วันนี้!",
        search_placeholder: "ค้นหาผลงาน, ผู้เขียน, แท็ก...",
        hall_of_fame: "หอเกียรติยศ (Weekly Best)",
        hall_of_fame_locked: "หอเกียรติยศสำหรับสมาชิกเท่านั้น",
        hall_of_fame_desc: "ใครคือผู้ใช้ที่ใช้งานมากที่สุดในสัปดาห์นี้? เข้าสู่ระบบเพื่อดูอันดับ!",
        login_btn: "เข้าสู่ระบบ",
        todays_pick: "ตัวเลือกวันนี้",
        continue_reading: "อ่านต่อ",
        trending: "กำลังมาแรง",
        new_arrivals: "มาใหม่",
        all_works: "ผลงานทั้งหมด",
        tag_cloud: "ตามแท็ก",
        filter_all: "ทั้งหมด",
        filter_webtoon: "เว็บตูน",
        filter_webnovel: "นิยายเว็บ",
        realtime_club: "คลับ Ssulwha เรียลไทม์",
        enter_club: "เข้าสู่",
        be_the_first: "ปล่อยดาวดวงแรก!",
        go_to_plaza: "ไปที่พลาซ่า",
        search_results: "ผลการค้นหา: '{query}'",
        search_no_results: "ไม่พบผลลัพธ์",
        search_try_other: "ลองใช้คำหลักอื่น",
        splash_loading: "กำลังเข้าสู่โลก Ssulwha...",
    },
    mypage: {
        tab_library: "ห้องสมุด",
        tab_history: "ประวัติ",
        tab_activity: "กิจกรรม",
        tab_likes: "รายการโปรด",
        tab_wallet: "กระเป๋าเงิน",
        tab_settings: "การตั้งค่า",
        no_activity: "ไม่มีกิจกรรม",
        go_to_plaza: "ไปที่พลาซ่า",
        followers: "ผู้ติดตาม",
        following: "กำลังติดตาม",
        edit_profile_tooltip: "แก้ไขโปรไฟล์",
        role_author: "นักเขียน",
        role_reader: "ผู้อ่าน",
        role_admin: "แอมิน",
        author_pending: "⏳ รอการอนุมัติ",
        btn_studio: "สตูดิโอผู้สร้าง",
        btn_apply_author: "เป็นนักเขียน",
        default_bio: "ป้อนคำแนะนำตัวสั้นๆ",
        menu_edit_profile: "แก้ไขโปรไฟล์",
        menu_public_profile: "โปรไฟล์สาธารณะ",
        current_version: "เวอร์ชันปัจจุบัน",
        invite_title: "เชิญเพื่อน",
        invite_reward: "รางวัล +500P",
        invite_desc: "แบ่งปันลิงก์ คุณและเพื่อนจะได้รับคนละ 500P!",
        invited_count: "เพื่อนที่เชิญ",
        unit_people: "คน",
        edit_profile_title: "แก้ไขโปรไฟล์",
        label_photo: "รูปโปรไฟล์",
        btn_upload: "อัปโหลด",
        btn_random: "สุ่ม",
        placeholder_photo_url: "หรือ URL รูปภาพ",
        label_nickname: "ชื่อเล่น",
        label_bio: "ประวัติย่อ",
        placeholder_bio: "แนะนำตัวสั้นๆ เกี่ยวกับตัวคุณ"
    },

    plaza: {
        title: "คลับ Ssulwha",
        subtitle: "พื้นที่สื่อสารอารมณ์สำหรับ Gen Z",
        btn_sync: "⚡ ซิงค์ความคิดเห็น (Admin Only)",
        composer_placeholder_init: "คุณต้องการปล่อยเรื่องราวใดสู่จักรวาลนี้?",
        composer_placeholder_thread: "เขียนเรื่องราวต่อ...",
        composer_placeholder_quote: "ฝากความคิดเห็นเกี่ยวกับเรื่องนี้...",
        btn_add_thread: "เพิ่มเธรด",
        btn_submit: "ปล่อยดาว",
        btn_submit_quote: "อ้างอิง",
        btn_submitting: "กำลังโหลด...",
        quote_suffix: " ได้อ้างอิง"
    },
    recommendation: {
        loading_title: "กำลังอ่านวิถีโคจรของคุณ...",
        loading_desc: "เชื่อมต่อรอยเท้าในอดีตและดวงดาวที่คุณเคยพักพิง",
        fallback_title: "กลุ่มดาวของ <span class=\"text-transparent bg-clip-text bg-gradient-to-r from-fuchsia-200 to-amber-200\">{name}</span><br>ยังดูเลือนลาง",
        fallback_desc: "แต่อย่ากังวล <br>เราได้เลือกเรื่องราวที่ส่องสว่างค่ำคืนของผู้อื่นมาให้คุณ<br><span class=\"text-sm opacity-70 mt-1 block\">เมื่อรอยเท้าของคุณเพิ่มขึ้น เราจะค้นหาวงโคจรเฉพาะสำหรับคุณ</span>",
        personal_title: "ชั้นหนังสือของ <span class=\"text-transparent bg-clip-text bg-gradient-to-r from-fuchsia-200 to-amber-200\">{name}</span>,<br>เรื่องราวสำหรับช่องถัดไป",
        personal_desc: "เราพบดาว 5 ดวงที่ตรงกับรสนิยมของคุณ",
        label_empty_shelf: "ชั้นหนังสือว่างเปล่า (The Empty Shelf)",
        btn_refresh: "คำแนะนำอื่นๆ",
        error_title: "การเชื่อมต่อไม่เสถียร",
        btn_retry: "ลองใหม่",
        empty_data_title: "ข้อมูลไม่เพียงพอ",
        btn_browse: "ดูผลงาน",
        widget_title: "กำลังมองหาหนังสือ<br>เล่มถัดไป?",
        widget_desc: "เราเลือก 5 ผลงานตามรสนิยมของ {name}",
        widget_desc_guest: "เราเลือก 5 ผลงานตามรสนิยมของคุณ",
        btn_check: "ดูเลย"
    },
    star_station: {
        title: "สถานีดวงดาว",
        subtitle: "เพลิดเพลินกับผลงานได้อย่างอิสระมากขึ้น",
        my_stars: "ดาวของฉัน",
        history_tab: "ประวัติ",
        products_tab: "สินค้า",
        payment_method: "วิธีการชำระเงิน",
        btn_charge: "เติมเงิน",
        history_empty: "ไม่มีประวัติการเติมเงิน",
        product_names: {
            stardust: "ผงดาว",
            shooting_star: "ดาวตก",
            little_bear: "หมีเล็ก",
            silver_river: "แม่น้ำสีเงิน",
            galaxy_master: "เจ้าแห่งดาราจักร",
            star_maker: "ผู้สร้างดวงดาว"
        }
    },
    studio: {
        title: "สตูดิโอสร้างสรรค์",
        desc: "พื้นที่สำหรับจินตนาการอันไม่มีที่สิ้นสุดของคุณ",
        dashboard: "แดชบอร์ด",
        series: "จัดการซีรีส์",
        statistics: "สถิติ",
        profit: "ผลกำไร",
        guide: "คู่มือผู้เขียน",
        new_series: "ซีรีส์ใหม่",
        edit_series: "แก้ไขซีรีส์",
        new_episode: "ตอนใหม่",
        edit_episode: "แก้ไขตอน",
        open_menu: "เปิดเมนู",
        exit: "ออก",
        lab_badge: "LAB",
        lab_title: "ห้องปฏิบัติการดา วินชี",
        lab_desc: "เปิดโลกใหม่แห่งการสร้างสรรค์ด้วย AI",
        total_views: "ยอดดู",
        total_likes: "ถูกใจ",
        total_followers: "ผู้ติดตาม",
        weekly_performance: "ผลงานรายสัปดาห์",
        views_trend_7d: "แนวโน้มยอดดู (7 วัน)",
        live_data: "สด",
        my_series_list: "ผลงานของฉัน",
        total_series_count: "ทั้งหมด {n} เรื่อง",
        empty_series_title: "เริ่มเรื่องราวใหม่",
        empty_series_desc: "เปิดจินตนาการของคุณสู่โลก",
        btn_editor: "บรรณาธิการ",
        btn_settings: "การตั้งค่า",
        btn_delete: "ลบ",
        delete_modal_title: "ลบซีรีส์",
        create_first_episode: "สร้างตอนแรกของคุณ!",
        create_first_episode_desc: "คลิกปุ่มตอนใหม่เพื่อเริ่มต้น",
        last_updated: "อัปเดตล่าสุด: {date}",
        delete_episode_title: "ลบตอน",
        delete_episode_content: "คุณแน่ใจหรือไม่ที่จะลบตอน '{title}'?",

        // Toolbar
        bold: "ตัวหนา",
        italic: "ตัวเอียง",
        highlight_red: "เน้น (แดง)",
        highlight_blue: "เน้น (น้ำเงิน)",
        save_preserve_status: "บันทึก (คงสถานะ)",
        delete_modal_content: "คุณแน่ใจหรือไม่ที่จะลบ '{title}'? การกระทำนี้ไม่สามารถยกเลิกได้"
    },
    editor: {
        davinci_editor: "ตัวแก้ไข DaVinci",
        webnovel_editor: "ตัวแก้ไข Webnovel",
        webtoon_editor: "ตัวแก้ไข Webtoon",
        episode_title: "ชื่อตอน",
        placeholder_title: "ใส่ชื่อตอน",
        content: "เนื้อหา",
        placeholder_content: "เขียนเรื่องราวของคุณที่นี่...",
        author_note: "บันทึกของนักเขียน",
        placeholder_note: "คำพูดถึงผู้อ่านของคุณ...",
        upload_image: "อัปโหลดรูปภาพ",
        upload_cover: "อัปโหลดปก",
        save_draft: "บันทึกร่าง",
        publish: "เผยแพร่",
        ai_analysis: "วิเคราะห์ AI",
        ai_recommend: "แนะนำ AI",
        tags: "แท็ก",
        placeholder_tags: "เพิ่มแท็ก (คั่นด้วยจุลภาค)",
        preview: "ดูตัวอย่าง",
        cover_image: "Cover Image",
        cover_url: "Cover URL",
        series_status: "Series Status",
        admin_info: "Admin Info",
        format: "Format",

        publish_now: "Publish",
        settings: "การตั้งค่า",
        episode_prefix: "ตอน",
        draft_mode_title: "โหมดร่าง",
        draft_mode_private_desc: "ตอนนี้ถูกซ่อนอยู่ในขณะนี้",
        display_mode: "โหมดแสดงผล",
        mode_webtoon: "เว็บตูน (เลื่อน)",
        mode_comic: "คอมิก (หน้า)",
        mode_insta: "ลงอินสตา",
        mode_desc: "ปรับประสบการณ์การรับชมให้เหมาะสม",
        thumbnail: "ภาพย่อ",
        bgm: "BGM",
        manuscript_images: "ต้นฉบับ",
        drag_drop_hint: "ลากและวางรูปภาพ หรือ แตะเพื่ออัปโหลด",
        set_draft: "เป็นร่าง",
        save_changes: "บันทึกการเปลี่ยนแปลง",
        live_preview: "ดูตัวอย่างสด",
        preview_hint: "ตรวจสอบว่าจะแสดงอย่างไรบนมือถือ",
        val_webtoon_error: "[ข้อผิดพลาดโหมดเว็บตูน] รูปภาพกว้างเกินไป (อัตราส่วน: {ratio})<br>โหมดเว็บตูนต้องการการเลื่อนแนวตั้ง (สูง > กว้าง * 1.2)<br>สำหรับหน้าเดี่ยว โปรดใช้โหมด 'คอมิก'",
        val_comic_error: "[ข้อผิดพลาดโหมดคอมิก] อัตราส่วนภาพไม่ถูกต้อง ({ratio})<br>รูปแบบที่อนุญาต:<br>- หน้าแนวตั้ง (ประมาณ 2:3 ถึง 3:4)<br>- หน้าคู่แนวนอน (กว้าง > สูง)<br><br>แถบยาวควรใช้โหมด 'เว็บตูน'",
        val_insta_error: "[ข้อผิดพลาดอินสตา] อัตราส่วนภาพไม่ถูกต้อง ({ratio})<br>การปรับให้เหมาะสมสำหรับ Instagram ต้องการจัตุรัส (1:1) หรือ แนวตั้ง (4:5)<br>รูปภาพปัจจุบันกว้างหรือสูงเกินไป",
        approval_requested: "ขออนุมัติแล้ว",
        approval_desc: "งานของคุณถูกส่งเพื่อขออนุมัติแล้ว\\nจะถูกเผยแพร่หลังจากผู้ดูแลระบบตรวจสอบ",
        pending_approval: "รอการอนุมัติ",
        saved_to_draft: "บันทึกไปยังร่างแล้ว",
        published_start_ai: "ตอนเผยแพร่แล้ว! กำลังเริ่มวิเคราะห์ AI...",
        ai_trigger_fail: "เริ่มวิเคราะห์ AI ล้มเหลว โปรดใช้ปุ่ม 'วิเคราะห์ AI' ด้วยตนเอง",
        save_failed: "บันทึกล้มเหลว: {e}",
        upload_complete: "อัปโหลดเสร็จสมบูรณ์",
        upload_fail_desc: "การอัปโหลดรูปภาพล้มเหลว (การสร้าง URL ล้มเหลว)\nโปรดตรวจสอบบันทึกคอนโซล",
        image_mode_mismatch: "รูปภาพที่เลือกไม่ตรงกับข้อกำหนดของโหมด {mode}",
        invalid_format: "รูปแบบไม่ถูกต้อง",
        mode_change_blocked: "ถูกบล็อกการเปลี่ยนโหมด",
        mode_change_blocked_desc: "รูปภาพที่มีอยู่บางรูปไม่ตรงกับข้อกำหนด {mode} โปรดลบออกและลองอีกครั้ง",
        processing: "กำลังประมวลผล...",
        tap_nav_hint: "แตะขอบเพื่อนำทาง หรือ เลื่อน",
        ai_analyze_title: "ยืนยันการวิเคราะห์ AI",
        ai_analyze_confirm: "เรียกใช้การวิเคราะห์ AI (OCR) บนรูปภาพเหล่านี้หรือไม่?\\nข้อมูลการวิเคราะห์ที่มีอยู่จะถูกอัปเดต",
        save_required: "โปรดบันทึกตอนก่อน",
        ai_requesting: "กำลังร้องขอเซิร์ฟเวอร์ AI... (OCR/SEO)",
        ai_processing_title: "กำลังประมวลผล AI",
        ai_no_items: "ไม่มีรายการวิเคราะห์ (0)\\n\\n[รายละเอียด]\\n{log}",
        diagnosis_report: "รายงานการวินิจฉัย",
        ocr_complete: "OCR เสร็จสมบูรณ์: {n} เฟรม",
        seo_trigger: "เริ่มสร้าง SEO อัตโนมัติแล้ว",
        ai_complete_desc: "การวิเคราะห์เสร็จสมบูรณ์\\n- สร้างข้อมูล OCR แล้ว\\n- ข้อมูลเมตา SEO รอดำเนินการ\\n(จะแสดงในไม่ช้า)",
        ai_error: "ข้อผิดพลาดการประมวลผล AI",
        ai_fail_msg: "การวิเคราะห์ AI ล้มเหลว: {e}",
        title: "Novel Studio",
        master_detail: "Master-Detail View",
        save: "บันทึก",
        saved: "บันทึกแล้ว",
        saving: "กำลังบันทึก...",
        complete: "เสร็จสิ้น",
        error: "ข้อผิดพลาด",
        ai_analyze_btn: "วิเคราะห์ AI",
        ai_analyzing: "กำลังวิเคราะห์...",
        series_info: "ข้อมูลซีรีส์ (Upload)",
        series_title: "ชื่อซีรีส์",

        admin_readonly: "แอดมินเท่านั้น (Read Only)",
        chapters: "รายการบท",
        add_chapter: "เพิ่มบท",
        delete_chapter_confirm: "ลบบทนี้?",
        untitled_episode: "ไม่มีชื่อ",
        bgm_label: "BGM (ตัวเลือก)",
        content_body: "เนื้อหา",
        load_txt: "โหลด TXT",
        text_too_short: "ข้อความสั้นเกินไป",
        upload_cover_fail: "อัปโหลดปกไม่สำเร็จ",
        create_series: "สร้างซีรีส์",
        edit_series: "แก้ไขซีรีส์",
        basic_info: "ข้อมูลพื้นฐาน",
        episode_mgmt: "จัดการตอน",
        compliance: "ความสอดคล้อง (Compliance)",
        age_rating: "เรตติ้งอายุ",
        age_guide: "คู่มือ",
        is_ai: "ใช้เนื้อหา AI",
        desc_placeholder: "ป้อนคำอธิบายโครงเรื่อง...",


        format_locked: "ล็อคแล้ว",
        webtoon: "เว็บตูน (Webtoon)",
        webnovel: "นิยายเว็บ (Webnovel)",
        cinenovel: "ซีเนโนเวล (Cine-Novel)",
        admin_id: "รหัส ID (Admin Only)",
        ai_context_analysis_confirm: "Run AI Context Analysis?\n(Existing data will be overwritten)",
        ai_analyzing_background: "Requesting AI Analysis... (Background)",
        ai_no_items_found: "No items analyzed...",

        creating_episode: "Creating New Episode...",
        episode_not_found: "Episode not found.",
        uploading_images_toast: "Uploading images...",
        approval_request_sent: "Approval request sent. (Pending Admin Review)",
        publish_success: "Successfully Published!",
        temp_saved_toast: "Temporarily Saved.",
        deleted_toast: "Deleted.",
        access_denied: "Access Denied",

        series_info_upload: "Series Info (Upload)",
        cover_upload_fail: "Cover Upload Failed: ",
        save_success: "Saved",
        publish_confirm: "Confirm Publish",


        input_title_placeholder: "Enter title",
        ai_analyze_local: "AI Analyze (Local)",
        back_to_list: "Back to List",
        edit: "Edit",
        delete: "Delete",
        ai_analyze_admin: "AI Analyze (Admin)",
        ai_confirm: "AI Confirm",


        publish_complete: "Publish Complete",
        save_complete: "Save Complete",

        free_limit_placeholder: "Leave empty for global/series default",
        free_limit_desc: "* Overrides global settings if set.",
        admin_edit_anytime: "* Admin can edit this anytime.",
        cancel: "ยกเลิก",
        create: "สร้าง",
        episode_list: "รายการตอน",
        status_published: "เผยแพร่แล้ว",
        status_draft: "ร่าง",
        edit_detail_guide: "Edit details in editor",
        refreshing_list: "Refreshing list...",
        load_fail: "Load failed: ",
        no_cover: "No Cover",
        badge_ai: "AI Generated",
        no_episodes: "No episodes.",
        open_editor_fullscreen: "Open Editor (Fullscreen)",




        ai_analysis_fail: "AI Analysis Failed: ",
        save_fail: "Save Failed: ",

        bold: "Bold",
        italic: "Italic",
        highlight_red: "Highlight (Red)",
        highlight_blue: "Highlight (Blue)",
        save_preserve_status: "Save (Preserve Status)",
        new_episode: "New Episode",


        novel_editor: "Webnovel Editor",
        auto_saved: "Auto Saved",
        untitled_chapter: "Untitled",
        chapter_title_placeholder: "Chapter Title",
        publish_settings: "Publish Settings",
        delete_title: "Delete Chapter",
        save_button: "Save",
        novel_info: "Novel Info",
        novel_title: "Novel Title",
        tags_placeholder: "Romance, Fantasy",
        chapter_list: "Chapter List",
        chapter_count: "Total {n} Episodes",
        add_empty_chapter: "Add Empty Chapter",

        public_toggle: "Public",
        private_toggle: "Private",
        bgm_suno_label: "BGM Settings",
        txt_upload: "Upload TXT",

        ai_analysis_complete: "AI Analysis Complete",
        recommend_keywords: "Keywords",
        hook: "Hook",
        analysis_saved: "Data saved.",
        analysis_fail: "Analysis failed.",
        analysis_short: "Content too short.",
        age_all: "All",
        age_12: "12+",
        age_15: "15+",
        age_19: "19+",
        rating_label: "Rating",
        age_19_desc: "Blocks minors.",

        free_limit: "จำกัดฟรี (Local Override)",

        editor_guide_text: "* ใช้ 'เปิดเอดิเตอร์' เพื่อทำการเปลี่ยนแปลง",
        admin_zone: "โซนแอดมิน",
        admin_zone_desc: "ข้อมูลนี้ถูกจำกัด",
        download_csv: "ดาวน์โหลด CSV (ISBN)",
        adult_confirm_title: "คำเตือน 18+",
        adult_confirm_body: "ตั้งค่าเป็น 'ผู้ใหญ่ (19+)' หรือไม่?\\n\\n- จะบล็อกผู้เยาว์ไม่ให้เข้าถึง\\n- อาจต้องยืนยันตัวตน",
        davinci_lock_title: "🚧 กำลังพัฒนา",
        davinci_lock_desc: "โหมดดา วินชี (Cine-Novel) อยู่ในช่วงทดสอบเบต้า<br>เข้าถึงได้เฉพาะ <strong>ผู้ดูแลระบบ</strong> เนื่องจากความไม่เสถียร<br><div class='mt-3 text-rose-400 font-bold'>เร็วๆ นี้</div>",
        preview_preparing: "กำลังเตรียมดูตัวอย่าง...",
        upload_fail: "อัปโหลดล้มเหลว: ใช้ URL",
        select_chapter: "เลือกบท",
        episode_placeholder: "เช่น ตอนที่ 1 จุดเริ่มต้น",
        bgm_placeholder: "Suno AI URL...",
        content_placeholder: "เริ่มเรื่องราวของคุณ...",
        note_placeholder: "คำพูดถึงผู้อ่าน...",

    },

    rating_guide: {
        title: "คู่มือการจัดระดับเนื้อหา",
        all_title: "ทุกวัย",
        all_desc: "เนื้อหาเหมาะสำหรับทุกวัย<br>ไม่มีหรือมีความรุนแรง เนื้อหาทางเพศ หรือภาษาที่ไม่เหมาะสมเพียงเล็กน้อย",
        title_12: "12+ (วัยรุ่น)",
        desc_12: "อาจมีความรุนแรงเล็กน้อย ภาษาหยาบคาย หรือความสยองขวัญ<br>แนะนำให้ผู้ปกครองให้คำแนะนำสำหรับเด็กอายุต่ำกว่า 12 ปี",
        title_15: "15+ (เยาวชน)",
        desc_15: "อาจมีความรุนแรงปานกลาง ภาษาที่รุนแรง หรือประเด็นสำหรับผู้ใหญ่<br>อาจแสดงพฤติกรรมทางอาญาหรือข้อห้ามทางสังคม",
        title_19: "19+ (ผู้ใหญ่เท่านั้น)",
        desc_19: "มีเนื้อหาทางเพศที่ชัดเจน ความรุนแรงรุนแรง หรือภาษาที่หยาบคาย<br><strong class='text-red-500'>จำกัดทางกฎหมายสำหรับผู้ใหญ่ที่มีอายุ 19 ปีขึ้นไป จำเป็นต้องยืนยันตัวตน</strong>",
        disclaimer: "* การจัดระดับเป็นความรับผิดชอบของผู้เขียน การจัดระดับเท็จอาจนำไปสู่การเปลี่ยนแปลงบังคับหรือบทลงโทษ",
        confirm: "เข้าใจแล้ว"
    },
    davinci: {
        episode_settings: "การตั้งค่าตอน",
        title: "ชื่อเรื่อง",
        thumbnail: "ภาพย่อ",
        bgm: "BGM",
        add_block: "เพิ่มบล็อก",
        text_block: "ข้อความ",
        image_block: "รูปภาพ",
        upload_image: "อัปโหลดรูป",
        upload_thumb: "อัปโหลดภาพย่อ",
        upload_success: "อัปโหลดแล้ว",
        bgm_placeholder: "Suno URL หรือลิงก์ MP3",
        tip: "เคล็ดลับ:",
        drag_tip: "ลากบล็อกเพื่อจัดเรียง",
        save_draft: "บันทึกร่าง",
        publish: "เผยแพร่",
        saving: "กำลังบันทึก...",
        published: "เผยแพร่แล้ว! ผู้อ่านสามารถดูได้",
        publish_confirm: "เผยแพร่เลยหรือไม่? ผู้อ่านจะเห็นสิ่งนี้",
        preview_preparing: "กำลังเตรียมดูตัวอย่าง...",
        thumbnail_uploading: "กำลังอัปโหลดภาพย่อ...",
        thumbnail_applied: "ใช้ภาพย่อแล้ว",
        guide: {
            title: "คู่มือปุ่ม",
            save: "บันทึก",
            save_desc: "บันทึกการเปลี่ยนแปลง",
            draft: "ฉบับร่าง",
            draft_desc: "เปลี่ยนเป็นส่วนตัว",
            publish: "เผยแพร่",
            publish_desc: "เปิดเป็นสาธารณะ (ผู้อ่านมองเห็นได้)",
            auto_save: "บันทึกอัตโนมัติ",
            auto_save_on: "เปิด (3 วิ)",
            auto_save_desc: "บันทึกอัตโนมัติทุก 3 วินาที"
        }
    },
    intro: {
        slogan: "ความคิดสร้างสรรค์ของมนุษย์, ความสามารถในการขยายตัวของ AI",
        hero_title: "ปลาบาเบล",
        hero_subtitle: "สำหรับ ซีนี-โนเวล",
        status_active: "ระบบแปลภาษาทำงาน",
        status_cine: "รูปแบบ ซีนี-โนเวล",
        desc_1: "อ่าน IP เกาหลีได้ทันทีใน <span class='text-white font-bold mx-1'>10 ภาษา</span> ด้วยระบบ AI แบบไม่ทำลายต้นฉบับของเรา",
        desc_2: "สัมผัส <span class='text-white font-bold mx-1'>รูปแบบไฮบริดแห่งแรกของโลก</span> ที่ภาพและนิยายผสมผสานกันอย่างลงตัว",
        cta_start: "เริ่มอ่านฟรี",
        compare_title: "แบบทำลาย vs แบบไม่ทำลาย",
        compare_desc: "เราไม่เคยแตะต้องพิกเซลต้นฉบับ ดูความแตกต่างสิ",
        compare_old: "วิธีเก่า (กล่องขาว)",
        compare_new: "Ssulwha Engine (R.A.P.S)",
        white_box_removed: "ลบกล่องขาวแล้ว",
        format_title: "เหนือกว่าภาพนิ่ง",
        format_desc: "ภาพเว็บตูน ความลึกซึ้งของนิยาย ความดื่มด่ำแบบภาพยนตร์",
        geo_title: "การเติบโตที่ขับเคลื่อนด้วย AI",
        geo_desc: "เราไม่ทำการตลาด AI ของเราทำให้",
        term_log_1: "กำลังวิเคราะห์เนื้อหา...",
        term_log_2: "กำลังดึงคำหลัก...",
        term_log_3: "กำลังฉีดข้อมูล Meta JSON-LD...",
        term_log_4: "การเติบโตแบบออร์แกนิก +300%",

        // Missing Keys Added
        slider_old_title: "วิธีเก่า",
        slider_old_desc: "บดบังศิลปะ",
        slider_new_title: "Ssulwha Engine (R.A.P.S)",
        slider_new_desc_1: "\"นี่คือสิ่งที่ควรจะเป็น\"",
        slider_new_desc_2: "ข้อความลอยอยู่อย่างเป็นธรรมชาติ โดยยังคงรักษาผลงานศิลปะไว้",

        phone_analyzing: "กำลังวิเคราะห์...",
        phone_detected: "ตรวจพบ",
        phone_text_1: "นี่คือโชคชะตาของฉันเหรอ?",
        phone_cine_ep: "ซีเน-โนเวล EP.01",
        phone_cine_text_1: "แสงไฟนีออนกะพริบ สะท้อนในดวงตาที่เย็นชาของเขา",
        phone_cine_text_2: "\"มันไม่ใช่แค่การแปล\" เขาพึมพำ \"มันคือความจริงใหม่\"",

        footer_copyright: "ขับเคลื่อนโดย R.A.P.S Engine"
    }
};
